module.exports = __webpack_public_path__ + "img/balaoDeObservacao.e576e122.svg";